/* Lunai ozadja — season filtering + named blob downloads.
   Downloads: fetch -> blob -> a[download] (CORS on cdn.shopify.com
   allows it); on any failure the image opens in a new tab and a quiet
   helper line appears. Anchors stay fully functional without JS. */
(function () {
  'use strict';

  function initSection(root) {
    var savedText = root.getAttribute('data-saved-text') || '';
    var helpText = root.getAttribute('data-help-text') || '';
    var grid = root.querySelector('[data-oz-grid]');
    var chips = root.querySelectorAll('[data-oz-chip]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* Season chips — client-side filter with a soft crossfade. */
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var target = chip.getAttribute('data-oz-chip');
        chips.forEach(function (c) {
          c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
        });
        var apply = function () {
          root.querySelectorAll('[data-oz-card]').forEach(function (card) {
            var season = card.getAttribute('data-season');
            card.hidden = target !== 'all' && season !== target;
          });
          if (grid) grid.classList.remove('is-fading');
        };
        if (reduce.matches || !grid) {
          apply();
        } else {
          grid.classList.add('is-fading');
          window.setTimeout(apply, 180);
        }
      });
    });

    /* Downloads. */
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-oz-dl]');
      if (!a || !root.contains(a) || a.classList.contains('is-busy')) return;
      if (!window.fetch || !window.URL || !URL.createObjectURL) return; /* native anchor fallback */
      e.preventDefault();

      var card = a.closest('[data-oz-card]');
      var status = card && card.querySelector('[data-oz-status]');
      a.classList.add('is-busy');
      a.setAttribute('aria-busy', 'true');
      if (status) status.textContent = '';

      fetch(a.href, { mode: 'cors' })
        .then(function (r) {
          if (!r.ok) throw new Error('http ' + r.status);
          return r.blob();
        })
        .then(function (blob) {
          var url = URL.createObjectURL(blob);
          var tmp = document.createElement('a');
          tmp.href = url;
          tmp.download = a.getAttribute('data-fname') || 'lunai-ozadje.jpg';
          document.body.appendChild(tmp);
          tmp.click();
          tmp.remove();
          window.setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
          if (status) {
            status.textContent = savedText;
            window.setTimeout(function () {
              if (status.textContent === savedText) status.textContent = '';
            }, 3000);
          }
        })
        .catch(function () {
          window.open(a.href, '_blank', 'noopener');
          if (status) status.textContent = helpText;
        })
        .then(function () {
          a.classList.remove('is-busy');
          a.removeAttribute('aria-busy');
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-oz]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-init inside the theme editor when the section re-renders. */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-oz]');
    if (root) initSection(root);
  });
})();
